export const entity = {
  invOverview: {
    name: 'Resumen Inventario',
    overStock: 'En Exceso',
    safetyStock: 'Stock de Seguridad',
    outOfStock: 'Agotado',
  },
};
